const SingleProduct = {
  // mobileContainer: '.spc-mobile',
  // desktopContainer: '.spc-desktop',
  // quantityContainer: '.quantity',
  // quantityContent: null,
  // breakPoint: 1024,
  // emptyContent: '',
  // isMobileActive: false,

  init() {
    let _this = this;

    _this.activateTriggers();

    _this.activatePopup();
  },

  activatePopup() {
    // $('body').on('added_to_cart', function () {
    //   $('#mini-cart').addClass('active');
    //   $('#single-product-notice').slideDown();
    //   setTimeout(function () {
    //     $('#single-product-notice').slideUp();
    //   }, 3600);
    // });
  },

  activateTriggers() {
    const minus = $('.product-quantity-action[data-action="minus"]');
    const plus = $('.product-quantity-action[data-action="plus"]');

    minus.off('click').on('click', function () {
      const input = $(this).next().find('.qty');

      const currVal = parseInt(input.val());
      const newVal = currVal <= 1 ? 1 : currVal - 1;
      input.val(newVal);
      input.attr('value', newVal);
    });

    plus.off('click').on('click', function () {
      const input = $(this).prev().find('.qty');

      const maxVal = parseInt(input.attr('max'));
      const currVal = parseInt(input.val());
      const newVal = currVal >= maxVal ? maxVal : currVal + 1;
      input.val(newVal);
      input.attr('value', newVal);
    });
  },
};

export default SingleProduct;
